import React from 'react';
import type {ListItemProps} from '@tempo/core';
import {ListItem} from '@tempo/core';
import type {RenderResultFunction} from './types';

type SearchResultProps<T> = {
	id: string;
	item: any;
	index: number;
	renderSearchResult: RenderResultFunction<T>;
	onClick: (item: T, index: number) => void;
} & Omit<ListItemProps, 'onClick'>;

const SearchResult = <T,>({
	id,
	item,
	index,
	renderSearchResult,
	onClick,
	...rest
}: SearchResultProps<T>) => {
	const handleClick = () => {
		onClick(item, index);
	};

	const handleKeyDown = (e: React.KeyboardEvent<HTMLLIElement>) => {
		if (e.key === 'Enter') {
			onClick(item, index);
		}
	};

	// TODO reconsider the colors
	return (
		<ListItem
			id={id}
			tabIndex={0}
			_hover={{bgColor: 'background.neutral.secondary.hovered'}}
			_focusVisible={{
				bgColor: 'background.neutral.secondary.hovered',
				outline: 'none',
			}}
			py={1}
			px={3}
			cursor="pointer"
			onClick={handleClick}
			onKeyDown={handleKeyDown}
			borderRadius="4px"
			{...rest}
		>
			{renderSearchResult(item, index)}
		</ListItem>
	);
};

export default SearchResult;
